import { defineMessages } from 'react-intl';

const Common = defineMessages({
  account: {
    id: 'Common.account',
    defaultMessage: 'Account',
    description: 'Account Label/Title',
  },
  add: {
    id: 'Common.add',
    defaultMessage: 'Add',
    description: 'Add Label',
  },
  all: {
    id: 'Common.all',
    defaultMessage: 'All',
    description: 'All Label',
  },
  and: {
    id: 'Common.and',
    defaultMessage: 'and',
    description: 'Common seperator for messages',
  },
  assign: {
    id: 'Common.assign',
    defaultMessage: 'Assign',
    description: 'Assign Label',
  },
  customers: {
    id: 'Common.customers',
    defaultMessage: 'Customers',
    description: 'Label for any "Customers" features',
  },
  gotIt: {
    id: 'Common.gotIt',
    defaultMessage: 'Got It!',
    description: 'Common button confirmation text',
  },
  cancel: {
    id: 'Common.cancel',
    defaultMessage: 'Cancel',
    description: 'Button that allows the user to cancel their current action',
  },
  checklists: {
    id: 'Common.checklists',
    defaultMessage: 'Checklists',
    description: 'Label for the Checklists',
  },
  clear: {
    id: 'Common.clear',
    defaultMessage: 'Clear',
    description: 'Button that allows the user to clear their current selection',
  },
  close: {
    id: 'Common.close',
    defaultMessage: 'Close',
    description: 'Button label for closing something - usually a modal or menu',
  },
  collaborations: {
    id: 'Common.collaborations',
    defaultMessage: 'Collaborations',
    description: 'Label for the Collaborations',
  },
  comingSoon: {
    id: 'Common.comingSoon',
    defaultMessage: 'Coming Soon',
    description: 'Message for upcoming features',
  },
  comments: {
    id: 'Common.comments',
    defaultMessage: 'Comments',
    description: 'label for Comments',
  },
  contacts: {
    id: 'Common.contacts',
    defaultMessage: 'Contacts',
    description: 'Label for Contacts',
  },
  error: {
    id: 'Common.error',
    defaultMessage: 'Well, Shoot.',
    description: 'Message for error states',
  },
  documents: {
    id: 'Common.documents',
    defaultMessage: 'Documents',
    description: 'Label for the Documents',
  },
  save: {
    id: 'Common.save',
    defaultMessage: 'Save',
    description: 'Save button',
  },
  remove: {
    id: 'Common.remove',
    defaultMessage: 'Remove',
    description: 'Label for option to remove an item',
  },
  delete: {
    id: 'Common.delete',
    defaultMessage: 'Delete',
    description:
      'Label for a menu option that allows the user to delete a photo or document',
  },
  moveToTrash: {
    id: 'Common.moveToTrash',
    defaultMessage: 'Move to Trash',
    description:
      'Label for a menu option that allows the user to move an item to the trash',
  },
  deleteProject: {
    id: 'Common.deleteProject',
    defaultMessage: 'Delete Project',
    description:
      'Label for a menu option that allows the user to delete a project',
  },
  confirmDeleteMessage: {
    id: 'Common.confirmDeleteMessage',
    defaultMessage: 'Are you sure you want to delete this item?',
    description: 'Message to confirm the deletion of an item',
  },
  confirmDelete: {
    id: 'Common.confirmDelete',
    defaultMessage: 'Yes, delete',
    description: 'Button that allows the user to approve the deletion',
  },
  cancelDelete: {
    id: 'Common.cancelDelete',
    defaultMessage: "No, don't delete",
    description: 'Button that allows the user to cancel the deletion',
  },
  companyName: {
    id: 'Common.companyName',
    defaultMessage: 'Company Name',
    description: 'input field label for company name',
  },
  emailAddress: {
    id: 'Common.emailAddress',
    defaultMessage: 'Email Address',
    description: 'Label describing an Email Address input field',
  },
  workEmail: {
    id: 'Common.workEmail',
    defaultMessage: 'Work Email',
    description: 'Work email title',
  },
  phoneNumber: {
    id: 'Common.phoneNumber',
    defaultMessage: 'Phone Number',
    description: 'Label describing a Phone Number input field',
  },
  otherTitle: {
    id: 'Common.other',
    defaultMessage: 'Other',
    description: 'Other label',
  },
  toggleOn: {
    id: 'Common.toggleOn',
    defaultMessage: 'Yes',
    description: 'affirmative label for the yes/no toggle',
  },
  toggleOff: {
    id: 'Common.toggleOff',
    defaultMessage: 'No',
    description: 'negative label for the yes/no toggle',
  },
  photos: {
    id: 'Common.photos',
    defaultMessage: 'Photos',
    description: 'Label for the Photos menu option',
  },
  download: {
    id: 'Common.download',
    defaultMessage: 'Download',
    description: 'Button that allows the user to download an item',
  },
  downloadOriginal: {
    id: 'Common.downloadOriginal',
    defaultMessage: 'Download Original',
    description: 'Button that allows the user to download an original item',
  },
  downloadModified: {
    id: 'Common.downloadModified',
    defaultMessage: 'Download Modified',
    description: 'Button that allows the user to download a modified item',
  },
  downloadPDF: {
    id: 'Common.downloadPDF',
    defaultMessage: 'Download PDF',
    description: 'Label for Download PDF option',
  },
  new: {
    id: 'Common.new',
    defaultMessage: 'New',
    description: 'Text to indicate a new feature',
  },
  update: {
    id: 'Common.update',
    defaultMessage: 'Update',
    description: 'Button that allows the user to submit their updates',
  },
  updating: {
    id: 'Common.updating',
    defaultMessage: 'Updating…',
    description: 'Message telling the user that their changes are processing',
  },
  loadMore: {
    id: 'Common.loadMore',
    defaultMessage: 'Load More',
    description: 'Button that allows the user to load more content',
  },
  loading: {
    id: 'Common.loading',
    defaultMessage: 'Loading…',
    description: 'Message telling the user that content is loading',
  },
  reports: {
    id: 'Common.reports',
    defaultMessage: 'Reports',
    description: 'Label for the Reports',
  },
  share: {
    id: 'Common.share',
    defaultMessage: 'Share',
    description: 'Button that allows the user to share an item',
  },
  share_copyLink: {
    id: 'Common.share.copyLink',
    defaultMessage: 'Copy Link',
    description: 'Button that allows the user to copy the link to the document',
  },
  share_copied: {
    id: 'Common.share.copied!',
    defaultMessage: 'Copied!',
    description:
      'message to the user confirming that they have clicked the Copy Link button',
  },
  share_email: {
    id: 'Common.share.email',
    defaultMessage: 'Email',
    description: 'Button that allows the user to share something via an email',
  },
  done: {
    id: 'Common.done',
    defaultMessage: 'Done',
    description: 'Button that allows the user to complete their current action',
  },
  confirm: {
    id: 'Common.confirm',
    defaultMessage: 'Confirm',
    description: 'Button that confirms the users selections',
  },
  menu: {
    id: 'Common.menu',
    defaultMessage: 'Menu',
    description: 'Label for menu',
  },
  search: {
    id: 'Common.search',
    defaultMessage: 'Search',
    description: 'Search label',
  },
  title: {
    id: 'Common.title',
    defaultMessage: 'Title',
    description: 'Title label',
  },
  type: {
    id: 'Common.type',
    defaultMessage: 'Type',
    description: 'Type label',
  },
  tags: {
    id: 'Common.tags',
    defaultMessage: 'Tags',
    description: 'Tags label (for image tags)',
  },
  labels: {
    id: 'Common.labels',
    defaultMessage: 'Labels',
    description: 'Labels label (for project labels)',
  },
  users: {
    id: 'Common.users',
    defaultMessage: 'Users',
    description: 'Users Label',
  },
  groups: {
    id: 'Common.groups',
    defaultMessage: 'Groups',
    description: 'Groups Label',
  },
  people: {
    id: 'Common.people',
    defaultMessage: 'People',
    description: 'People Label',
  },
  projects: {
    id: 'Common.projects',
    defaultMessage: 'Projects',
    description: 'Projects Label',
  },
  ariaLabelWaveEmoji: {
    id: 'Common.ariaLabelWaveEmoji',
    defaultMessage: 'Waving hand emoji',
    description: 'aria label for waving hand emoji',
  },
  thisCompany: {
    id: 'Common.thisCompany',
    defaultMessage: 'this company',
    description: 'placeholder for company name',
  },
  edit: {
    id: 'Common.edit',
    defaultMessage: 'Edit',
    description: 'Copy to edit content',
  },
  create: {
    id: 'Common.create',
    defaultMessage: 'Create',
    description: 'Message for create content',
  },
  continue: {
    id: 'Common.continue',
    defaultMessage: 'Continue',
    description: 'Continue text',
  },
  learnMore: {
    id: 'Common.learnMore',
    defaultMessage: 'Learn More',
    description: 'Learn More text',
  },
  tryAgain: {
    id: 'Common.tryAgain',
    defaultMessage: 'Try Again',
    description: 'Try again text',
  },
  active: {
    id: 'Common.active',
    defaultMessage: 'Active',
    description: 'Active text',
  },
  uhOh: {
    id: 'Common.uhOh',
    defaultMessage: 'Uh Oh!',
    description: 'common error title',
  },
  copy: {
    id: 'Common.copy',
    defaultMessage: 'Copy',
    description:
      'Message for copying trusty links (invite, payment requests, etc)',
  },
  copySuccess: {
    id: 'Common.copySuccess',
    defaultMessage: 'Link Copied to Clipboard',
    description: 'Success text if link is copied to clipboard',
  },
  retry: {
    id: 'Common.retry',
    defaultMessage: 'Retry',
    description:
      'Message to retry fetch requests for trusty links (invite, payment requests, etc)',
  },
  hidePhotos: {
    id: 'Common.hidePhotos',
    defaultMessage: 'Hide Photos',
    description: 'Common title for trusty media features',
  },
  hidePhoto: {
    id: 'Common.hidePhoto',
    defaultMessage: 'Hide Photo',
    description: 'Common pluralized title for trusty media features',
  },
  numberSelected: {
    id: 'Common.numberSelected',
    defaultMessage: '{count} Selected',
    description: 'Commonly used when selecting multiple items',
  },
  view: {
    id: 'Common.view',
    defaultMessage: 'View',
    description: 'View text',
  },
  export: {
    id: 'Common.export',
    defaultMessage: 'Export',
    description: 'Export text',
  },
  exportPdf: {
    id: 'Common.exportPdf',
    defaultMessage: 'Export PDF',
    description: 'Export PDF text',
  },
  exportToPdf: {
    id: 'Common.exportToPdf',
    defaultMessage: 'Export to PDF',
    description: 'Export to PDF text',
  },
  recentlyUsed: {
    id: 'Common.recentlyUsed',
    defaultMessage: 'Recently Used',
    description: 'Recently Used text',
  },
  templates: {
    id: 'Common.templates',
    defaultMessage: 'Templates',
    description: 'Templates text',
  },
  changesSaved: {
    id: 'Common.changesSaved',
    defaultMessage: 'Changes Saved',
    description: 'Changes Saved text',
  },
});

export default Common;
